import { Button, Group, Text } from '@mantine/core'
import { notifications } from '@mantine/notifications'
import { pinIdleMinutes } from '@tnn/core'
import { ResponsiveDialog, SectionCard } from '@tnn/ui'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PinSetup } from './Pin'
import { useSession } from './session'

/**
 * On one's account page: what the PIN is for, and a new one (the password, then the PIN twice). None with the PIN off
 * (`/api/me` says `pin: null`: `PIN_OFF` on a developer's machine)
 */
export function PinCard() {
  const { t } = useTranslation()
  const { me } = useSession()
  const [open, setOpen] = useState(false)
  if (!me.pin) return null
  return (
    <SectionCard title={t('pin.card')}>
      <Group justify="space-between" wrap="nowrap" align="flex-start" gap="md">
        <Text size="sm" c="dimmed">
          {t('pin.cardBody', { minutes: pinIdleMinutes })}
        </Text>
        <Button variant="light" onClick={() => setOpen(true)} style={{ flexShrink: 0 }}>
          {t('pin.changeTitle')}
        </Button>
      </Group>
      <ResponsiveDialog opened={open} onClose={() => setOpen(false)} title={t('pin.changeTitle')} size="sm">
        {open && (
          <PinSetup
            username={me.user.username}
            withPassword
            onDone={() => {
              setOpen(false)
              notifications.show({ message: t('pin.saved') })
            }}
          />
        )}
      </ResponsiveDialog>
    </SectionCard>
  )
}
